<template>
  <modal :showModal="abierto" contentWidth="560px">
    <template #content>
      <div class="qr-totem">
        <div class="qr-totem__title">{{ $t(titulo) }}</div>
        <div class="qr-totem__text">{{ $t(texto) }}</div>
        <img class="qr-totem__qr" :src="qr" :alt="$t(titulo)" />
        <div
          class="button-movistar button-movistar__primary"
          @click="emit('cerrar')"
        >
          {{ $t('totem.qr.close') }}
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
  /*
   * El QR que sale en el totem en lugar de abrir una pagina.
   *
   * En el totem no se puede mandar a nadie a rellenar sus datos en una
   * pantalla publica, y una ventana nueva se queda abierta para el siguiente
   * que pase: lo que hacia el kiosko de antes era ensenar un QR para seguir en
   * el movil, y eso es lo que se hace aqui.
   *
   * Se cierra solo pasado un rato, para que el siguiente visitante no se
   * encuentre el QR del anterior.
   */
  import { onBeforeUnmount, watch } from 'vue'
  import modal from '@/components/movistar/modals/Modal.vue'

  const props = defineProps({
    abierto: { type: Boolean, default: false },
    qr: { type: String, required: true },
    titulo: { type: String, default: 'totem.qr.title' },
    texto: { type: String, default: 'totem.qr.text' }
  })
  const emit = defineEmits(['cerrar'])

  // El mismo minuto que la vuelta a la portada: si no, el QR se quedaria encima.
  const SEGUNDOS_ABIERTO = 60
  let reloj = null

  watch(
    () => props.abierto,
    (abierto) => {
      clearTimeout(reloj)
      if (abierto) {
        reloj = setTimeout(() => emit('cerrar'), SEGUNDOS_ABIERTO * 1000)
      }
    }
  )

  onBeforeUnmount(() => clearTimeout(reloj))
</script>

<style scoped lang="scss">
  @import '@/scss/mixings';

  .qr-totem {
    @include d-flex(column, flex-start, center, 24px);
    width: 100%;
    text-align: center;

    &__title {
      font-size: 28px;
      font-weight: 500;
      color: var(--dark-color);
    }

    &__text {
      font-size: 20px;
      line-height: 1.4;
      color: var(--dark-color);
    }

    &__qr {
      width: 360px;
      max-width: 100%;
      height: auto;
    }
  }
</style>
